import React from 'react';
import {
    useLocation,
    useNavigate,
    useParams
  } from "react-router-dom";
  
interface RouterProps {
    location: ReturnType<typeof useLocation>;
    navigate: ReturnType<typeof useNavigate>;
    params: ReturnType<typeof useParams>;
}

interface WithRouterProps {
    router: RouterProps;
}

function withRouter<P extends WithRouterProps>(Component: React.ComponentType<P>) {
    function ComponentWithRouterProp(props: Omit<P, 'router'>) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (
            <Component
                {...props as P}
                router={{ location, navigate, params }}
            />
        );
    }

    return ComponentWithRouterProp;
}

export default withRouter;